/*
 * Authors: mariushirjanu
 * Created: 18/12/2023
 */
import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { AgCellValidatorService, IAgCellValidatorParam } from './ag-cell-validator.service';

export const AG_CELL_VALIDATOR:string = 'ag-cell-validator';

// The ag-cell-validator is a cell renderer responsible for displaying validation error messages in the tooltip and marking the cell as invalid.
// Additionally, the agCellValidatorService.validateCell() can be used to retrieve the list of error messages for a specific cell.

@Component({
  selector: AG_CELL_VALIDATOR,
  template: `
      <div [popover]="validationMessages || params?.colDef?.headerName" [attr.data-validation]="validationMessages" triggers="mouseenter:mouseleave" container="body" placement="auto">
        <span *ngIf="validationMessages?.length">
          <i class="fa fa-exclamation-circle"></i>&nbsp;
        </span>
        <span [innerHTML]="formattedValue"></span>
      </div>
  `
})
export class AgCellValidatorComponent implements ICellRendererAngularComp {

  public params!:ICellRendererParams;
  public formattedValue:string;
  public iconClass:string;
  public validationMessages:string;

  constructor(
    private agCellValidatorService:AgCellValidatorService
  ){
    /***/
  }
  public agInit(params:ICellRendererParams):void {
    this.params = params;
    this.formattedValue = params?.valueFormatted || params?.getValue();
    this.validationMessages = this.agCellValidatorService.validateCell(<IAgCellValidatorParam>params).join('\n');
  }

  public refresh(params:ICellRendererParams):boolean {
    this.params = params;
    return true;
  }
}